// extracted by mini-css-extract-plugin
module.exports = {"section":"SearchAuthorList__section","sectionTitle":"SearchAuthorList__sectionTitle","content":"SearchAuthorList__content"};